import {createSelector, createStructuredSelector} from 'helpers';
import {id} from 'store/common';
import {index} from './notes';
import {categoriesById} from './categories';
import {images} from 'store/files/selectors';
import {collaboration, editable} from 'store/relations';
import {saved} from 'store/server';

export const note = createSelector(
  [ index, id ],
  ( index, id ) => index[id],
);

const category = createSelector(
  [ note, categoriesById ],
  ( note, categoriesById ) => note && categoriesById[note.categoryId || note.category],
);

export const details = createStructuredSelector({
  category,
  images,
  collaboration,
  editable,
  note,
  saved,
});
